import apiClient from "./ApiClient";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export const callUpdateChangePasswordApi = (params) => {
    return apiClient.post(baseUrl + '/user/account/updateChangePassword', params)
};

// 현재 비밀번호 입력값을 받지않고 신규 비밀번호 값만 받는 API
export const callUpdateChangePasswordApi2 = (params) => {
    return apiClient.post(baseUrl + '/user/account/updateChangePassword2', params)
};

export const callUpdateChangePasswordSkipApi = (params) => {
    return apiClient.post(baseUrl + '/user/account/updateChangePasswordSkip', params)
};

export const callSaveDeviceInfoApi = (params) => {
    return apiClient.post(baseUrl + '/user/account/saveDeviceInfo', params)
};

// 로그아웃 시 디바이스 푸시 토큰 정리(서버에서 삭제 → 그 기기로 더는 푸시 안 감)
export const callClearDeviceInfoApi = (params) => {
    return apiClient.post(baseUrl + '/user/account/clearDeviceInfo', params)
};

export const callSelectFindIdApi = (params) => {
    return apiClient.post(baseUrl + '/user/account/selectFindId', params)
};

export const callSelectFindPasswordApi = (params) => {
    return apiClient.post(baseUrl + '/user/account/selectFindPassword', params)
};

// 현재 로그인 사용자 정보 조회
export const callSelectFindAccountInfo = () => {
    return apiClient.get(baseUrl + "/user/account/getAccountInfo")
}

// 현재 로그인 사용자 정보 변경(활동명, 이메일, 전화번호)
export const callChangeAccount = (params) => {
    return apiClient.post(baseUrl + "/user/account/changeAccount", params)
}

// 현재 로그인 사용자 회원탈퇴
export const callAccountRemove = () => {
    return apiClient.get(baseUrl + "/user/account/accountRemove")
}

// 현재 로그인 사용자 회원비밀번호 확인
export const callCheckPassword = (param) => {
    return apiClient.post(baseUrl + "/user/account/checkPassword", param)
}

//푸시 디바이스 토큰 저장
export const callSavePushInfoApi = (params) => {
    return apiClient.post(baseUrl + '/user/account/savePushInfo', params)
};